import {
  generateUtilityClasses,
  ListItem,
  styled,
  listItemIconClasses,
  listItemTextClasses,
  formControlLabelClasses,
} from '@mui/material';

const opacity = 0.4;

export const COMPONENT_NAME = 'PrcExtendedListItemDocument';

export const documentListItemclasses = {
  ...generateUtilityClasses(COMPONENT_NAME, ['opacityDelete']),
};

export const ListItemStyled = styled(ListItem)(({ theme }) => ({
  marginTop: theme.spacing(4),
  [`&.${documentListItemclasses.opacityDelete}`]: {
    [`.${listItemIconClasses.root}`]: {
      opacity,
    },
    [`.${listItemTextClasses.root}`]: {
      opacity,
    },
    [`.${formControlLabelClasses.root}`]: {
      opacity,
    },
  },
}));
